// extracted by mini-css-extract-plugin
export default {"headerClass":"Mabd5w8mgDqSU9C6sIimh","headerClassV2":"_17EKHmXaHlrVkZLF7QhZ0h"};